export default __webpack_public_path__ + "staticlp1/media/crescer.749b910a.jpg";